(function () {

    'use strict';

    angular.module('iplusjs.input.kfzKennzeichen', [
        'lodash',
        'iplusjs.utils.misc'
    ])
        .component('iplusjsInputKfzKennzeichen', {
            templateUrl: 'common/input/inputKfzKennzeichen.html',
            require: {
                form: '^form'
            },
            bindings: {
                name: '@name',
                model: '=ngModel',
                label: '@iikkLabel',
                options: '<iikkOptions',
                onChangeFn: '&iikkdOnChange'
            },
            transclude: true,
            controller: InputKfzKennzeichenController,
            controllerAs: 'inputKfzKennzeichenVm'
        });

    InputKfzKennzeichenController.$inject = [
        'lodash',
        'MiscUtilsService'
    ];
    function InputKfzKennzeichenController(_, MiscUtilsService) {
        var vm = this,
            formFieldNames = [
                'unterscheidungszeichen',
                'erkennungsnummer1',
                'erkennungsnummer2',
                'kennzeichen'
            ],
            regexPkw = /^(?=.{2,12}$)([A-ZÄÜÖ]{1,3})-([A-Z]{1,2})\s(([0-9]{1,4}$)|([0-9]{1,4}[HVE]{1}))$/;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.onChange = onChange;
        vm.isAbweichendesKennzeichenFormat = isAbweichendesKennzeichenFormat;
        vm.getErrorText = getErrorText;
        vm.isKennzeichenEingabeVorhanden = isKennzeichenEingabeVorhanden;

        function onInit() {
            activate();
        }

        function onChanges() {
            activate();
        }

        function activate() {
            var value;

            vm.options = vm.options || {};

            vm.values = {};

            vm.required = _.isNil(vm.options.required) ? true : vm.options.required;

            vm.regexUnterscheidungszeichen = /^([A-ZÄÜÖ]{1,3})$/;
            vm.regexErkennungsnummer1 = /^([A-Z]{1,2})$/;
            vm.regexErkennungsnummer2 = /^([0-9]{1,4}$)|([0-9]{1,4}[HVE]{1})$/;

            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return _.compact([
                    vm.name,
                    fieldName
                ]).join('_');
            }));

            if (vm.model) {
                _.forEach(vm.formFieldNames, function (formFieldName) {
                    value = null;

                    if (_.endsWith(formFieldName, 'unterscheidungszeichen')) {
                        value = _.get(vm.model.match(regexPkw), '[1]');

                        if (value && vm.regexUnterscheidungszeichen.test(value)) {
                            vm.values[formFieldName] = value;
                        }
                    } else if (_.endsWith(formFieldName, 'erkennungsnummer1')) {
                        value = _.get(vm.model.match(regexPkw), '[2]');

                        if (value && vm.regexErkennungsnummer1.test(value)) {
                            vm.values[formFieldName] = value;
                        }
                    } else if (_.endsWith(formFieldName, 'erkennungsnummer2')) {
                        value = _.get(vm.model.match(regexPkw), '[3]');

                        if (value && vm.regexErkennungsnummer2.test(value)) {
                            vm.values[formFieldName] = value;
                        }
                    }
                });
            }
        }

        function onChange(name) {
            var modelValues = [],
                modelValue;

            vm.form[name].$validate();

            _.forEach(vm.formFieldNames, function (formFieldName) {
                modelValues.push(_.toUpper(_.get(vm.form[formFieldName], '$modelValue')));
            });

            modelValue = modelValues[0] + '-' + modelValues[1] + ' ' + modelValues[2];

            if (regexPkw.test(modelValue)) {
                vm.model = modelValue;
            } else {
                vm.model = null;
            }

            vm.onChangeFn({
                value: vm.model
            });
        }

        function isAbweichendesKennzeichenFormat() {
            if (!vm.model) {
                return false;
            }

            if (!regexPkw.test(vm.model)) {
                return true;
            }

            return false;
        }

        function getErrorText() {
            var isValid = true;

            _.forEach(vm.formFieldNames, function (formFieldName) {
                if (
                    vm.form[formFieldName] &&
                    ((
                        !_.get(vm.form[formFieldName], '$valid') &&
                        _.get(vm.form[formFieldName], '$dirty')
                    ) || (
                        _.get(vm.form, 'isSubmitted') &&
                        !_.get(vm.form[formFieldName], '$valid')
                    ))
                ) {
                    isValid = false;
                    return false;
                }
            });

            if (!isValid) {
                return 'Bitte geben Sie ein gültiges Kennzeichen ein.';
            }
        }

        function isKennzeichenEingabeVorhanden() {
            var isEingabeVorhanden = false;

            _.forEach(vm.formFieldNames, function (formFieldName) {
                if (MiscUtilsService.isNotEmpty(_.get(vm.form[formFieldName], '$viewValue'))) {
                    isEingabeVorhanden = true;
                    return false;
                }
            });

            return isEingabeVorhanden;
        }
    }

})();
